
import {
  FaClock, FaMoneyBillWave, FaShieldAlt, FaUsers,
  FaChartLine, FaLeaf
} from "react-icons/fa";

const benefits = [
  {
    icon: <FaClock />,
    title: "Save 70% Admin Time",
    desc: "Eliminate manual registers, spreadsheet tracking, and paper-based work orders. Everything is automated and centralized."
  },
  {
    icon: <FaMoneyBillWave />,
    title: "Reduce Asset Losses",
    desc: "Real-time tracking prevents assets from going missing. Every item has a digital record with full audit trail."
  },
  {
    icon: <FaShieldAlt />,
    title: "Never Miss Warranty Claims",
    desc: "Automated warranty expiry alerts ensure you claim repairs or replacements before the window closes."
  },
  {
    icon: <FaUsers />,
    title: "Better Team Coordination",
    desc: "Operators report issues, technicians get notified instantly, managers oversee everything — seamless cross-team collaboration."
  },
  {
    icon: <FaChartLine />,
    title: "Data-Driven Decisions",
    desc: "Visual dashboards and trend analysis help you plan budgets, replacements, and maintenance strategies with confidence."
  },
  {
    icon: <FaLeaf />,
    title: "Extend Equipment Life",
    desc: "Scheduled preventive maintenance and timely repairs dramatically increase the useful life of your critical equipment."
  }
];

const BenefitsSection = () => {
  return (
    <section id="benefits" className="lp-benefits">
      <div className="lp-benefits__inner">
        <div className="lp-section-header lp-section-header--light">
          <span className="lp-section-tag lp-section-tag--light">Benefits</span>
          <h2>Why Teams Trust This Platform</h2>
          <p>
            See real results from day one. Here's how this platform helps
            teams manage their assets better.
          </p>
        </div>

        <div className="lp-benefits__grid">
          {benefits.map((b, i) => (
            <div className="lp-benefits__card" key={i}>
              <div className="lp-benefits__icon">{b.icon}</div>
              <h3>{b.title}</h3>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
